<template>
	<div class="erji-content pp50">
		<div class="container">
			<div class="erji-title">
				<h1>{{title}}</h1>
				<h2>{{titleEn}}</h2>
			</div>
			<div class="erji-content-div">
				<div class="list01">
					<dl>
						<dd v-for="(item,index) in list" :key="index">
							<div class="list01_a" @click="toDetal(item)">{{item.title}}</div>
							<span class="span_11">{{item.created_at.slice(0,10)}}</span>
						</dd>
					</dl>
				</div>
				<div class="fenye" v-if="list && list.length>0">
					<el-pagination
						background
						layout="prev, pager, next"
						:total="this.pageObj.total"
						:page-size="pageNum"
						prev-text="上一页"
						next-text="下一页"
						:hide-on-single-page='this.pageObj.total < pageNum+1'
						@current-change="pageChange($event)"
						>
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'list',
		data(){
			return{
				title:'',
				titleEn:'',
				id:'',
				list:[],
				pageNum:10,
				pageObj:[],
				pagee:1
			}
		},
		methods:{
			res_menuClass(){
				this.axios.get('/api/menus/class?id=' + this.id)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.title = response.data.reslut.name;
							this.titleEn = response.data.reslut.sub_title;
						}
						
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//请求列表
			res_list(e,p){
				this.axios.get("/api/news/listNews?category_id="+this.id+"&limit="+ e +"&page="+p)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.pageObj = response.data.reslut;
							this.list = response.data.reslut.data;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			// 分页请求
			pageChange(curPage){
				this.res_list(this.pageNum,curPage)
			},
			//跳转详情页
			toDetal(item){
				$('html, body').animate({ scrollTop: 0 }, 0);
				this.$router.push({
					path:'/detail/'+item.parent_id,
					query:{
						category_id:item.category_id,
						id:item.id
					}
				})
			}
		},
		created(){
			this.id= this.$route.query.category_id
			this.res_menuClass()
			this.res_list(this.pageNum,this.pagee)
			// this.res_single(this.$route.query.category_id)
		},
		watch :{
			'$route' (to, from) {
					// 对路由变化作出响应...
					// console.log("single_to",to)
					// console.log("single_from",from)
					this.title = ''
					this.titleEn = ''
					this.list = ''
					this.id= this.$route.query.category_id
					this.res_menuClass()
					this.res_list(this.pageNum,this.pagee)
					// this.res_single(this.$route.query.category_id)
			}
		}
	}
</script>

<style>
</style>